import * as Types from '../../../gql/base-types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';

// =============================================================================
// Auto-generated by GraphQL Codegen - DO NOT EDIT
// Change the .gql source (or the schema) and re-run: pnpm codegen
// =============================================================================

const defaultOptions = {} as const;
export type GetManagedVehiclesQueryVariables = Types.Exact<{
  customerId: Types.Scalars['bigint']['input'];
}>;


export type GetManagedVehiclesQuery = { __typename?: 'query_root', mobility_vehicles: Array<{ __typename?: 'mobility_vehicles', id: number, customer_id: number, make: string, model: string, year?: number | null, color?: string | null, license_plate?: string | null, vin?: string | null, capacity?: number | null, status: string, created_at: string, updated_at: string }> };


export const GetManagedVehiclesDocument = gql`
    query GetManagedVehicles($customerId: bigint!) {
  mobility_vehicles(
    where: {customer_id: {_eq: $customerId}}
    order_by: [{updated_at: desc}]
  ) {
    id
    customer_id
    make
    model
    year
    color
    license_plate
    vin
    capacity
    status
    created_at
    updated_at
  }
}
    `;

/**
 * __useGetManagedVehiclesQuery__
 *
 * To run a query within a React component, call `useGetManagedVehiclesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetManagedVehiclesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetManagedVehiclesQuery({
 *   variables: {
 *      customerId: // value for 'customerId'
 *   },
 * });
 */
export function useGetManagedVehiclesQuery(baseOptions: Apollo.QueryHookOptions<GetManagedVehiclesQuery, GetManagedVehiclesQueryVariables> & ({ variables: GetManagedVehiclesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetManagedVehiclesQuery, GetManagedVehiclesQueryVariables>(GetManagedVehiclesDocument, options);
      }
export function useGetManagedVehiclesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetManagedVehiclesQuery, GetManagedVehiclesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetManagedVehiclesQuery, GetManagedVehiclesQueryVariables>(GetManagedVehiclesDocument, options);
        }
// @ts-ignore
export function useGetManagedVehiclesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetManagedVehiclesQuery, GetManagedVehiclesQueryVariables>): Apollo.UseSuspenseQueryResult<GetManagedVehiclesQuery, GetManagedVehiclesQueryVariables>;
export function useGetManagedVehiclesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetManagedVehiclesQuery, GetManagedVehiclesQueryVariables>): Apollo.UseSuspenseQueryResult<GetManagedVehiclesQuery | undefined, GetManagedVehiclesQueryVariables>;
export function useGetManagedVehiclesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetManagedVehiclesQuery, GetManagedVehiclesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetManagedVehiclesQuery, GetManagedVehiclesQueryVariables>(GetManagedVehiclesDocument, options);
        }
export type GetManagedVehiclesQueryHookResult = ReturnType<typeof useGetManagedVehiclesQuery>;
export type GetManagedVehiclesLazyQueryHookResult = ReturnType<typeof useGetManagedVehiclesLazyQuery>;
export type GetManagedVehiclesSuspenseQueryHookResult = ReturnType<typeof useGetManagedVehiclesSuspenseQuery>;
export type GetManagedVehiclesQueryResult = Apollo.QueryResult<GetManagedVehiclesQuery, GetManagedVehiclesQueryVariables>;
import { resolveExecutor, type GqlExecutor, type GqlRequestOptions } from '@hopdrive/sdk-core'


/**
 * @source {@link src/features/mobilityVehicles/queries/getManagedVehicles.query.gql}
 */
export async function getManagedVehicles(
  variables: GetManagedVehiclesQueryVariables,
  options?: { executor?: GqlExecutor; raw?: false } & GqlRequestOptions
): Promise<GetManagedVehiclesQuery['mobility_vehicles']>
export async function getManagedVehicles(
  variables: GetManagedVehiclesQueryVariables,
  options?: { executor?: GqlExecutor; raw: true } & GqlRequestOptions
): Promise<GetManagedVehiclesQuery>
export async function getManagedVehicles(
  variables: GetManagedVehiclesQueryVariables,
  options?: { executor?: GqlExecutor; raw?: boolean } & GqlRequestOptions
): Promise<GetManagedVehiclesQuery['mobility_vehicles'] | GetManagedVehiclesQuery> {
  const { executor, raw, ...requestOptions } = options ?? {}
  const result = await resolveExecutor(executor).query<GetManagedVehiclesQuery>(
    GetManagedVehiclesDocument,
    variables,
    requestOptions
  )
  if (raw) return result
  return result.mobility_vehicles
}